import React from 'react';
import PropTypes from 'prop-types';
import Page from "./page";
import ButtonNext from "./ButtonNext";

const Option = ({selected, text}) => (
    <div style={{
        ...styles.option,
        backgroundColor: selected ? '#00a499' : '#e4195f',
    }}>
        <div>{text}</div>
    </div>
);

Option.propTypes = {
    selected: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
};

const ResultMultipleChoice = ({navigateDeviceNext  = false, question, answer, options, screenshot}) => (
    <Page title={'Target Group Selection'}>
        <div className={'bodyContainer'} style={{justifyContent: 'center'}}>
            <div style={styles.container}>
                <div style={styles.title}>Resultaat</div>

                <div style={styles.resultContainer}>
                    <div style={styles.columnLeft}>
                    </div>
                    <div style={styles.columnRight}>
                        <div style={styles.question}>
                            {question}
                        </div>
                    </div>
                </div>
                <div style={styles.resultContainer}>
                    <div style={styles.columnLeft}>
                        <div>
                            <img src={screenshot} alt={'screenshot'} style={{borderRadius: '8px', width: '100%'}}/>
                        </div>
                    </div>
                    <div style={styles.columnRight}>
                        {options.map((o, index) => <Option key={index} text={o} selected={answer[index] === 1}/>)}
                    </div>
                </div>

                <div style={{marginTop: '120px', width: '100%'}}>
                    <ButtonNext navigateDeviceNext={navigateDeviceNext}/>
                </div>
            </div>
        </div>
    </Page>
);

ResultMultipleChoice.propTypes = {
    navigateDeviceNext: PropTypes.bool,
    question: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    answer: PropTypes.array.isRequired,
    screenshot: PropTypes.string.isRequired,
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    resultContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },
    columnLeft: {
        display: 'flex',
        width: 'calc(50% - 25px)',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    columnRight: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(50% - 25px)',
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        lineHeight: '48px',
        fontStyle: 'italic',
        paddingBottom: '25px',
        marginBottom: '105px',
        width: '100%',
    },
    question: {
        color: '#427A83',
        width: '100%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '22px',
        marginBottom: '25px',
        textAlign: 'center',
    },
    option: {
        display: 'flex',
        backgroundColor: '#e4195f',
        borderRadius: '8px',
        color: '#ffffff',
        fontFamily: 'Ubuntu',
        fontSize: '20px',
        marginBottom: '25px',
        padding: '10px',
        width: '100%',
    },
    optionCircle: {
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        width: '22px',
        height: '22px',
        marginLeft: '5px',
        marginRight: '15px',
    }
}

export default ResultMultipleChoice;
